import { ErrorHandled, ErrorRaised, UnhandledError } from 'app/core/error-handler/state/actions/index';

import { ErrorRaisedRemoved } from './error-raised.model';

export { ErrorActionType } from './error-action-type.model';
export { createErrorHandled, ErrorHandled } from './error-handled.model';
export { createErrorRaised, ErrorRaised } from './error-raised.model';
export { createUnhandledError, UnhandledError } from './unhandled-error.model';

export type ErrorActions =
  ErrorRaised |
  ErrorRaisedRemoved |
  ErrorHandled |
  UnhandledError;
